import color from "../styles/_helpers/branding.module.scss";

export interface IMicrositeThemeSettings {
  brandPrimaryColor: string;
  themeColor: string;
  themeCopyColor: string;
  invertedTheme: boolean;
}

type IMicrositeBrand = {
  headerThemeColor: string;
  brand: {
    primaryColor: string;
    secondaryColor: string;
  };
};

export default function getMicrositeBrandThemeSettings(microsite: IMicrositeBrand) {
  const themeColor =
    microsite.headerThemeColor === "Primary"
      ? microsite.brand?.primaryColor
      : microsite.headerThemeColor === "Secondary"
        ? microsite.brand?.secondaryColor
        : color.white;

  const themeCopyColor =
    microsite.headerThemeColor === "Primary" || microsite.headerThemeColor === "Secondary"
      ? color.white
      : color.copyColor;

  const brandPrimaryColor = microsite.brand?.primaryColor;

  const invertedTheme = microsite.headerThemeColor !== "Primary" && microsite.headerThemeColor !== "Secondary";

  return { themeColor, themeCopyColor, brandPrimaryColor, invertedTheme };
}
